// extracted by mini-css-extract-plugin
export default {"LoadingComponent":"loading_LoadingComponent__4L0Kt","loading":"loading_loading__+cQGD"};